import React from 'react';
import InspectionFormChild from '../InspectionFormChild';
// import * as _ from 'lodash';
import slug from 'constants/slug';
import { getOneInspectionDetail, updateOneInspectionDetail } from 'api/inspectionApi';
import Message from 'rc-message';
import PageLockHOC from 'hoc/pageLock';

@PageLockHOC(['facilityInspection.write'])
export default class InspectionEditChild extends React.Component {
  static propTypes = {};

  state = {
    _idObject: '',
    isLoading: true,
    initialValue: null,
  };

  async checkValidate() {
    const _id = _.result(this.props, 'match.params._id');
    if (_id) {
      const res = await getOneInspectionDetail(_id);
      if (res.success) {
        this.setState({
          _idObject: _id,
          isLoading: false,
          initialValue: res.data
        });
      }
    } else {
      this.props.history.push(slug.INSPECTTION.LIST);
    }
  }

  async componentWillMount() {
    await this.checkValidate();
  }

  getId() {
    const _id = _.result(this.props, 'match.params._id');
    return _id;
  }

  getParentId() {
    const parentId = _.result(this.props, 'match.params.parentId');
    return parentId;
  }

  handelSubmit = async (values) => {
    this.setState({
      isLoading: true,
    });

    const res = await updateOneInspectionDetail(this.state._idObject, values);
    if (res.success) {
      Message.success({ content: 'Sửa Thành Công' });
      this.props.history.push(`${slug.INSPECTTION.VIEW_WITH_ID_CHILD}${this.getId()}/${this.getParentId()}`)
    }
    if (res.error) Message.error({ content: res.message });
  };

  render() {
    return (
      <div>
        {!this.state.isLoading && (
          <div>
            <InspectionFormChild
              isEdit={true}
              initialValue={this.state.initialValue}
              onSubmit={this.handelSubmit}
              slugBack={slug.INSPECTTION.LIST}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Inspection/inspectionEditChild/index.js